import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Methods } from "../../../shared/methods";
import { UserService } from 'src/app/services/user.service';
import { User } from '../../../models/user';
declare var $: any;

@Component({
  selector: 'app-listvendors',
  templateUrl: './listvendors.component.html',
  styleUrls: ['./listvendors.component.css']
})
export class ListvendorsComponent implements OnInit, AfterViewInit {
  public token;
  public reps;
  public mtds: Methods = new Methods();
  @Input() vendors: Array<any> = [];
  @Input() options: Array<any> = [];
  @Output() newOptions: EventEmitter<any>;
  @Output() active: EventEmitter<number>;

  constructor( private _userService: UserService) {
    this.newOptions = new EventEmitter;
    this.active = new EventEmitter;
    this.token = this._userService.getToken();
  }
  ngOnInit() {
    this.GetRep();
  }
  
  GetRep() {
    this._userService.getAllUsersLite(this.token, "exceptuser").subscribe(
      response => {
        if (response.status == 'success') {
          this.reps = response.data; 
        }
      });
  }
  
  getRepName(managedById: number): string {
    if (this.reps) {
      const rep = this.reps.find(r => r.id === managedById);
      return rep ? `${rep.name} ${rep.surname}` : ''; 
    }
    return ''; 
  }
  ngAfterViewInit() {
    
    let visibility = [];
    for (let option of this.options) {
      visibility.push({
        targets: [option.origin],
        visible: option.visibility,
      });
    }
    
    let positions = [];
    while (positions.length < this.options.length) {
      for (let option of this.options) {
        if (option.position === positions.length) {
          positions.push(option.origin);
          break;
        }
      }
    }
    
    let table = $("#vendorsTable").DataTable({
      colReorder:
        positions.length !== 0
          ? {
              order: positions,
            }
          : true,
      columnDefs: visibility,
      dom: "Bflrtip",
      buttons: [
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "colvis",
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: "btn btn-sm btn-outline-info",
          titleAttr: "Column visibility",
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });

    table.on( 'column-reorder', function ( e, settings, details ) {
      
      for (let col of settings.aoColumns) {
        for (let option of this.options) {
          if (option.origin === col._ColReorder_iOrigCol) {
            option.position = col.idx;
            break;
          }
        }
      }
      this.newOptions.emit(this.options);
    }.bind(this) );

    table.on( 'column-visibility.dt', function ( e, settings, column, state ) {

      for (let option of this.options) {
        if (option.position === column) {
          option.visibility = state;
          break;
        }
      }
      this.newOptions.emit(this.options);
    }.bind(this) );
  }

  userActive(id) {
    this.active.emit(id);
  }

}
